<template>
   <div @mousedown="mouseDown" @mouseup="mouseUp"  :class="'summaryDisk glowBorder ' +selected +' ' +hasNew">
        <div :class="'discIcon '+label "></div>
        <div :class="'label '+hasNew"> {{label}}</div>
        <div :class="'count ' +hasNew">{{count}}</div>
           </div>
  
</template>

<script>
export default {
  components: {
   
  },
  props: [ "label","count","content","selected","unread"],
  data() {
    return {
     
     
      mode:"closed"
    };
  },
  computed: {
   hasNew(){
     if(this.unread){
       return "unread"
     }
     
   }
  },
  methods: {
    mouseDown(){
       this.$emit("mousedown")
    },
    mouseUp(){
       this.$emit("mouseup")
    },
   
  }
};
</script>

<style lang="scss">
@import "@/assets/sass/variables.scss";
.summaryDisk{
  font-size:14px;
  width:120px;
  height:120px;
  border-radius:50%!important;
  .unread{
    
    color:#08ea08;
  }
  
}
.summaryDisk.unread{
  border:#7cff7c solid;
 
    -webkit-box-shadow: #7cff7c 0px 0px 20px 0px, 0px 0px 50px 0px inset;
    box-shadow: #7cff7c 0px 0px 20px 0px, 0px 0px 50px 0px inset;
    border-radius: 5px;
    /*color: #7cff7c;*/
}
.summaryDisk.true {
    border: solid 3px $glow-text-colour-selected;
    background: #00ffff;
    box-shadow: inset 0px 0px 50px 0px;
    color: #03b;
    .unread{
    color:#014d00;
  }
  }
.summaryDisk.unread.label{
  color:#08ea08;
}
  .count{
    margin-top:10px;
    font-weight:600;
    font-size:18px;
  }
  
  .label{
    font-weight:600;
    font-size:16px;
    margin-top:50px;
  }
  .discIcon{
    position:absolute;
    width:120px;
    height:120px;
    background-size: 120px 480px;
    background-repeat: no-repeat;
    background-position: 0px 2px;
    background-image:url("../assets/images/icons/discIcons.png")
  }
  .discIcon.Documents{
    background-position: 0px -120px;
  }
  .discIcon.Locations{
    background-position: 0px -240px;
  }
  .discIcon.Evidence{
    background-position: 0px -360px;
  }
  .discIcon.Evidence{
    background-position: 0px -360px;
    .count.unread{
      color: #00bbff
    }
  }
  .node {
  position:absolute;
  width: 6px;
  height:6px;
  border: solid 3px $glow-colour;
  border-radius:50%!important
}


</style>